class Endpoints {
    static baseURL = "https://apichatgptresponse.managedcoder.com/api/";

    static addInfo = this.baseURL + "bd/createBdList";
}
export default Endpoints;